import { render, staticRenderFns } from "./fileCategory.vue?vue&type=template&id=076df3b3&"
import script from "./fileCategory.vue?vue&type=script&lang=js&"
export * from "./fileCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports